<template>
  <div class="tab_content">
    <div class="senior_search flex_style left" style="align-items: flex-start">
      <div class="left_filter">
        <div class="item_box" v-if="false">
          <v-checkbox
            class="all_checks"
            v-model="isAllType"
            :indeterminate="isIndeter"
            label="专利类型"
          >
          </v-checkbox>
          <v-list class="items">
            <v-list-item-group v-model="types" multiple color="primary">
              <v-list-item
                v-for="(b, index) in typeList"
                :key="index"
                :value="b"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content :title="b">
                    <v-list-item-title>
                      {{ b }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
        <div class="item_box second">
          <v-checkbox
            class="all_checks"
            v-model="isAllCountry"
            :indeterminate="isIndeter1"
            label="全球数据库"
          >
          </v-checkbox>
          <v-list class="items">
            <v-list-item-group v-model="country" multiple color="primary">
              <v-list-item
                v-for="(b, index) in cList"
                :key="index"
                :value="b.code"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content :title="b.name">
                    <v-list-item-title>
                      {{ b.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </div>
      <div class="right_input">
        <div class="right_input_navTop">
          <div class="tit">字段搜索</div>
          <router-link to="/help" target="_blank">
            <div class="help_text">
              <div class="icon"></div>
              <div class="text">使用帮助</div>
            </div>
          </router-link>
        </div>
        <div class="high_search_line">
          <v-row key="0">
            <v-col xs="2" sm="1" md="1"></v-col>
            <v-col xs="4" sm="4" md="1"><div>关键词</div></v-col>
            <v-col xs="6" sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="tsInfo.key2['ts0']"
                  outlined
                  dense
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList1"
                >
                </v-select>
              </div>
            </v-col>
            <v-col xs="6" sm="7" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="tsInfo.key3['ts0']"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col xs="6" sm="6" md="2" class="icon">
              <v-icon @click="tsNumList.push('ts' + tsNum++)"
                >mdi-plus-box</v-icon
              >
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in tsNumList" :key="item">
            <v-col xs="2" sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="tsInfo.key1[item]"
                  dense
                >
                </v-select>
              </div>
            </v-col>
            <v-col xs="4" sm="4" md="1"> <div>关键词</div></v-col>
            <v-col xs="6" sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="tsInfo.key2[item]"
                  outlined
                  dense
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList1"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="7" xs="6" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="tsInfo.key3[item]"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="2" md="2" xs="6" class="icon">
              <v-icon @click="reduce('ts', index)">mdi-minus-box</v-icon>
            </v-col>
          </v-row>
        </div>
        <div class="high_search_line">
          <v-row key="0">
            <v-col sm="1" xs="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="cpcInfo.key1['cpc0']"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="4" xs="4" md="1"><div>分类号</div></v-col>
            <v-col sm="6" xs="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="cpcInfo.key2['cpc0']"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList2"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="6" xs="6" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="cpcInfo.key3['cpc0']"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="6" xs="6" md="2" class="btn_icon1">
              <div class="icon1">
                <v-icon @click="cpcNumList.push('cpc' + cpcNum++)"
                  >mdi-plus-box</v-icon
                >
              </div>
              <span class="ipc_btn btn_item1" @click="openIpc('cpc0')"
                >IPC助手</span
              >
              <!-- 新添加的CPC助手
                <span class="ipc_btn btn_item1" @click="openIpc('cpc3')"
                >CPC助手</span> -->
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in cpcNumList" :key="item">
            <v-col sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="cpcInfo.key1[item]"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="1"><div>分类号</div></v-col>
            <v-col sm="3">
              <div class="common_input_style1">
                <v-select
                    v-model="cpcInfo.key2[item]"
                    outlined
                    :dense="true"
                    hide-details
                    item-text="value"
                    item-value="key"
                    :items="filterList2"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="4" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="cpcInfo.key3[item]"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="2" md="2" class="btn_icon1">
              <div class="icon1">
                <v-icon @click="reduce('cpc', index)">mdi-minus-box</v-icon>
              </div>
              <span class="ipc_btn btn_item1" @click="openIpc(item)"
                >IPC助手</span
              >
            </v-col>
          </v-row>
        </div>
        <div class="high_search_line">
          <v-row key="0">
            <v-col sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="nameInfo.key1['name0']"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="4" md="1" class="special"><div>名称/地址</div></v-col>
            <v-col sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="nameInfo.key2['name0']"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList3"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="6" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="nameInfo.key3['name0']"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="6" md="2" class="btn_icon1">
              <div class="icon1">
                <v-icon @click="nameNumList.push('name' + nameNum++)"
                  >mdi-plus-box</v-icon
                >
              </div>
              <span class="ipc_btn btn_item1" @click="openComp('name0')"
                >企业名称检索助手</span
              >
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in nameNumList" :key="item">
            <v-col sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="nameInfo.key1[item]"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="4" md="1" class="special"><div>名称/地址</div></v-col>
            <v-col sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="nameInfo.key2[item]"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList3"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="6" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="nameInfo.key3[item]"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="6" md="2" class="btn_icon1">
              <div class="icon1">
                <v-icon @click="reduce('name', index)">mdi-minus-box</v-icon>
              </div>
              <span class="ipc_btn btn_item1" @click="openComp(item)"
                >企业名称检索助手</span
              >
            </v-col>
          </v-row>
        </div>
        <div class="high_search_line">
          <v-row key="0">
            <v-col sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="appInfo.key1['app0']"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="4" md="1"><div>号码</div></v-col>
            <v-col sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="appInfo.key2['app0']"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList4"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="6" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="appInfo.key3['app0']"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="6" md="2" class="icon">
              <v-icon @click="appNumList.push('app' + appNum++)"
                >mdi-plus-box</v-icon
              >
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in appNumList" :key="item">
            <v-col sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="appInfo.key1[item]"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="4" md="1"><div>号码</div></v-col>
            <v-col sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="appInfo.key2[item]"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList4"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="6" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="appInfo.key3[item]"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="6" md="2" class="icon">
              <v-icon @click="reduce('app', index)">mdi-minus-box</v-icon>
            </v-col>
          </v-row>
        </div>
        <div class="high_search_line">
          <v-row key="0">
            <v-col sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="dateInfo.key1"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="3" md="1"><div>日期</div></v-col>
            <v-col sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="dateInfo.key2"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList5"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="2" md="5">
              <div class="flex_style left">
                <div class="common_input_style1 date_sel">
                  <v-select
                    v-model="dateKey"
                    outlined
                    :dense="true"
                    hide-details
                    item-text="value"
                    item-value="key"
                    :items="dateKeys"
                  >
                  </v-select>
                </div>
                <div class="dateChange_wrapper">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="common_input_style1">
                        <v-text-field
                          v-model="date"
                          label=""
                          readonly
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                          outlined
                        ></v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      v-model="date"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                  <span class="center_text" v-if="dateKey == '1'">至</span>
                  <v-menu
                    v-if="dateKey == '1'"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="common_input_style1">
                        <v-text-field
                          v-model="date1"
                          label=""
                          readonly
                          outlined
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      v-model="date1"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row key="0">
            <v-col sm="1" md="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="customInfo.key1['cus0']"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="4" md="1"><div>自定义</div></v-col>
            <v-col sm="6" md="3">
              <div class="common_input_style1">
                <v-select
                  v-model="customInfo.key2['cus0']"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList6"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="6" md="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="customInfo.key3['cus0']"
                  :dense="true"
                  hide-details
                  placeholder="可输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="6" md="2" class="icon">
              <v-icon @click="customNumList.push('app' + customNum++)"
                >mdi-plus-box</v-icon
              >
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in customNumList" :key="item">
            <v-col sm="1">
              <div class="common_input_style1 opt_item">
                <v-select
                  :items="opt"
                  label=""
                  outlined
                  hide-details
                  v-model="customInfo.key1[item]"
                  :dense="true"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="1"><div>自定义</div></v-col>
            <v-col sm="3">
              <div class="common_input_style1">
                <v-select
                  v-model="customInfo.key2[item]"
                  outlined
                  :dense="true"
                  hide-details
                  item-text="value"
                  item-value="key"
                  :items="filterList6"
                >
                </v-select>
              </div>
            </v-col>
            <v-col sm="5">
              <div class="common_input_style1">
                <v-text-field
                  outlined
                  v-model="customInfo.key3[item]"
                  :dense="true"
                  hide-details
                  placeholder="请输入关键字"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="2" class="icon">
              <v-icon @click="reduce('custom', index)">mdi-minus-box</v-icon>
            </v-col>
          </v-row>
        </div>
        <v-row v-if="false">
          <v-col sm="2">
            <v-select
              :items="opt"
              label=""
              outlined
              v-model="oprValue[index]"
              :dense="true"
            >
            </v-select>
          </v-col>
          <v-col sm="3">
            <v-combobox
              v-model="selValue[index]"
              outlined
              :dense="true"
              :items="test"
              label="筛选条件"
            >
              <template v-slot:append-item>
                <v-tabs :vertical="true">
                  <v-tab v-for="(item, index) in filterKeys" :key="index">{{
                    item.type
                  }}</v-tab>
                  <v-tab-item v-for="(item, index) in filterKeys" :key="index">
                    <div
                      class="padsm hand"
                      v-for="(item1, index1) in item.list"
                      :key="index1"
                      @click="selValue[index] = item1"
                    >
                      {{ item1 }}
                    </div>
                  </v-tab-item>
                </v-tabs>
              </template>
            </v-combobox>
          </v-col>
          <v-col sm="5">
            <v-text-field
              outlined
              v-model="inputValue[index]"
              :dense="true"
              label="关键字"
              placeholder="请输入关键字"
            ></v-text-field>
          </v-col>
          <v-col sm="2">
            <v-btn outlined>关键词助手</v-btn>
          </v-col>
        </v-row>
        <v-row class="high_search_btnbox">
          <v-col sm="3"> </v-col>
          <v-col sm="7">
            <!-- <v-btn @click="num = num+1">添加字段</v-btn> -->
            <div class="flex_style center">
              <v-btn class="btn btn1" @click="createSearch">生成检索式</v-btn>
              <v-btn class="btn btn2 marleft" @click="goSearch">检索</v-btn>
              <v-btn class="btn btn3 marleft" @click="clearSearch">清空</v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              class="starte_textarea"
              name="input-7-4"
              label=""
              placeholder="在上方字段中输入检索词，在此处预览您的检索式"
              v-model="totalTemp"
            ></v-textarea>
          </v-col>
        </v-row>
        <div class="strate_bottom">
          <div class="strate_btn_list">
            <v-btn class="btn btn1" @click="saveSearch">保存检索式</v-btn>
            <v-btn class="btn btn2 marleft" @click="goSearch1">检索</v-btn>
            <v-btn class="btn btn3 marleft" @click="clearSearch1">清空</v-btn>
          </div>
          <div class="starte_tRight">搜索结果： {{ patCount }}条</div>
        </div>
        <v-row>
          <v-col class="white_tabs">
            <v-tabs>
              <v-tab key="1">保存的检索式</v-tab>
              <v-tab-item key="1">
                <div class="common_tabs_wrapper">
                  <strategyList
                    :queryList="queryList"
                    @setQuery="getQuery"
                  ></strategyList>
                </div>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </div>
    </div>
        <!-- ipc助手 -->
     <v-dialog v-model="ipcDialog" width="70%">
      <v-card class="ipcList_dialog">
        <v-card-title class="headline lighten-2"> 
          <div class="flex_style betw" style="width: 100%;">
              <h4>IPC检索工具</h4>
              <v-icon @click="ipcDialog = false">mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <div class="ipcList_box">
              <div class="ipc_box_top">
                   <div class="top_center">
                     <div class="input_item">
                      <v-text-field
                        label=""
                        v-model="ipcKeyWord"
                        placeholder="请输入分类号或者关键词"
                        outlined
                        hide-details
                      ></v-text-field>
                    </div>
                    <v-btn color="primary" @click="searchIpc">搜索</v-btn>
                   </div>
              </div>
              <div class="ipc_box_center">
                <div class="ipc_lefts">
                  <v-treeview
                    :items="ipcList"
                    activatable
                    item-key="name"
                    open-on-click  
                  >
                    <!-- <template v-slot:prepend="{ item }">
                      <v-icon v-if="item.isParent&&item.children&&item.children.length<=0" @click="getChild(item.code)">mdi-menu-right</v-icon>
                    </template> -->
                    <template v-slot:label="{ item}">
                      <div class="flex_style betw item_cons">
                        <span class="tit_overflow text" v-if="item.isParent"  @click="getChild(item.code)">{{item.name}}</span>
                        <span class="tit_overflow text" v-if="!item.isParent">{{item.name}}</span>
                        <span class="icon" @click="sendIpc(item)"> <v-icon>mdi-plus</v-icon></span>
                      </div>
                      <!-- <div v-if="leaf" @click="getChild(item.children,item.code)">{{item.name}}</div> -->
                    </template>
                  </v-treeview>
                  <!-- <div class="item" v-for="item in ipcList" :key="item.id" @click="getChild(item.code)">
                      {{item.name}}
                      <div class="" v-for="item1 in item.children" :key="item1.id">{{item1.name}}</div>
                  </div> -->
                </div>
                <div class=""></div>
                <div class="ipc_rights">
                    <div class="item" v-for="item in sendItems" :key="item.id">
                      <span class="text">{{item.name}}</span>
                      <v-icon @click="ipcDelete(item.id)">mdi-minus</v-icon>
                    </div>
                </div>
              </div>
            </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <span @click="toseniorSearch">转入高级检索</span> -->
          <v-btn @click="toseniorSearch">转入高级检索 </v-btn>
          <v-btn @click="goSearch2" color="primary"> 检索 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="compDialog" width="70%">
      <v-card class="ipcList_dialog">
        <v-card-title class="headline lighten-2"> 
          <div class="flex_style betw" style="width: 100%;">
              <h4>企业名称检索工具</h4>
              <v-icon @click="compDialog = false">mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <div class="ipcList_box">
              <div class="ipc_box_top">
                   <div class="top_center">
                     <div class="input_item">
                      <v-text-field
                        label=""
                        v-model="compKeyWord"
                        placeholder="请输入企业名称"
                        outlined
                        hide-details
                      ></v-text-field>
                    </div>
                    <v-btn color="primary" @click="searchComp">搜索</v-btn>
                   </div>
              </div>
              <div class="ipc_box_center">
                <div class="ipc_lefts">
                  <v-treeview
                    :items="compList"
                    activatable
                    item-key="name"
                    open-on-click
                  >
                    <template v-slot:label="{ item}">
                      <div class="flex_style betw item_cons">
                        <span class="tit_overflow text" @click="getChild1(item.code)">{{item.name}}</span>
                        <span class="icon" @click="sendComp(item)"> <v-icon>mdi-plus</v-icon></span>
                      </div>
                      <!-- <div v-if="leaf" @click="getChild(item.children,item.code)">{{item.name}}</div> -->
                    </template>
                  </v-treeview>
                  <!-- <div class="item" v-for="item in ipcList" :key="item.id" @click="getChild(item.code)">
                      {{item.name}}
                      <div class="" v-for="item1 in item.children" :key="item1.id">{{item1.name}}</div>
                  </div> -->
                </div>
                <div class=""></div>
                <div class="ipc_rights">
                    <div class="item" v-for="item in sendItems1" :key="item.id">
                      <span class="text">{{item.name}}</span>
                      <v-icon @click="compDelete(item.id)">mdi-minus</v-icon>
                    </div>
                </div>
              </div>
            </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <span @click="toseniorSearch">转入高级检索</span> -->
          <v-btn @click="toseniorSearch1">转入高级检索 </v-btn>
          <v-btn @click="goSearch3" color="primary"> 检索 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import topNav from "@/components/widgets/topNav.vue";
import strategyList from "@/components/strategy/list.vue";
import ImageUpload from "@/components/uploadImage.vue";
import { getPnc } from "../../../../assets/js/methods";
import Qs from "qs";
import { mapState, mapMutations, mapActions } from "vuex";
import axios from 'axios';
export default {
  name: "advancedSearch",
  components: {
    topNav,
    ImageUpload,
    strategyList,
  },
  data() {
    return {
      sendItems1: [],
      compKeyWord: '',
      compList:[],
      compDialog: false,
      sendItems: [],
      ipcList: [],
      ipcDialog:false,
      ipcKeyWord: '',
      multiple: false,
      cpcNumList: [],
      nameNum: 1,
      isAllType: false,
      isIndeter: false,
      types: [],
      typeList: ["发明公开", "实用新型", "外观设计", "发明授权"],
      isAllCountry: false,
      isIndeter1: false,
      country: [],
      cList: [],
      list: [],
      menu: false,
      queryList: false,
      patCount: 0,
      date: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      menu1: false,
      rspnation:
        "cn;;;jp;;;us;;;kr;;;wo;;;de;;;gb;;;fr;;;ca;;;tw;;;au;;;es;;;ru;;;zn;;;at;;;it;;;in;;;br;;;eu;;;se;;;no;;;ch;;;fi;;;dk;;;pl;;;mx;;;nl;;;be;;;il;;;hk;;;za;;;my;;;hu;;;pt;;;ar;;;ua;;;cz;;;id;;;nz;;;sg;;;gr;;;ro;;;ea;;;ie;;;tr;;;cl;;;sh;;;vn;;;ph;;;si;;;pe;;;bg;;;hr;;;sk;;;co;;;lu;;;ap;;;uy;;;cy;;;rs;;;md;;;th;;;tn;;;ec;;;lt;;;eg;;;oa;;;ma;;;mn;;;mo;;;cr;;;lv;;;ee;;;gt;;;is;;;cu;;;mc;;;ge;;;do;;;jo;;;pa;;;sa;;;gc;;;sm;;;me;;;sv;;;ni;;;zw;;;hn;;;bn;;;zm;;;dz;;;mt;;;bh;;;py;;;ke;;;mw;;;ve;;;tj;;;ae;;;bo;;;ba;;;kz;;;bd;;;iq;;;by;;;la;;;kh;;;sy;;;uz;;;az;;;mk;;;tm;;;am;;;kg;;;tt",
      dateKeys: [
        {
          key: "1",
          value: "时间段",
        },
        {
          key: "2",
          value: "天",
        },
      ],
      dateKey: "1",
      tsInfo: {
        key1: {},
        key2: {},
        key3: {},
      },
      cpcInfo: {
        key1: { cpc0: "AND" },
        key2: {},
        key3: {},
      },
      nameInfo: {
        key1: { name0: "AND" },
        key2: {},
        key3: {},
      },
      appInfo: {
        key1: { app0: "AND" },
        key2: {},
        key3: {},
      },
      customInfo: {
        key1: { cus0: "AND" },
        key2: {},
        key3: {},
      },
      dateInfo: {
        key1: "AND",
        key2: "",
        key3: "",
      },
      tsNumList: [],
      opt: ["AND", "OR", "NOT"],
      nameNumList: [],
      appNumList: [],
      dateNumList: [],
      customNumList: [],
      totalTemp: "",
      filterList1: [
        {
          key: "ts",
          value: "标题摘要",
        },
        {
          key: "ti",
          value: "标题",
        },
        {
          key: "s",
          value: "摘要",
        },
        {
          key: "cl",
          value: "权利要求",
        },
        {
          key: "tsc",
          value: "标题，摘要，权利要求",
        },
        {
          key: "desc",
          value: "说明书",
        },
        {
          key: "tscd",
          value: "全文",
        },
      ],
      filterList2: [
        {
          key: "ipc",
          value: "ipc(国际分类)",
        },
        {
          key: "fi",
          value: "fi(日本分类)",
        },
        {
          key: "ft",
          value: "ft(日本分类)",
        },
        {
          key: "loc",
          value: "洛迦诺分类",
        },
        {
          key: "cpc",
          value: "cpc(合作专利分类)",
        },
      ],
      filterList3: [
        {
          key: "ap",
          value: "申请人",
        },
        {
          key: "in",
          value: "发明（设计）人",
        },
        {
          key: "caee",
          value: "当前专利权人",
        },
        {
          key: "at",
          value: "代理人",
        },
        {
          key: "ag",
          value: "代理机构",
        },
        {
          key: "addr",
          value: "申请人地址",
        },
        {
          key: "province",
          value: "省份",
        },
        {
          key: "city",
          value: "城市",
        },
      ],
      filterList4: [
        {
          key: "dn",
          value: "公开(公告)号",
        },
        {
          key: "an",
          value: "申请号",
        },
        {
          key: "pr",
          value: "优先权号",
        },
      ],
      filterList5: [
        {
          key: "ad",
          value: "申请日",
        },
        {
          key: "dd",
          value: "公开(公告)日",
        },
      ],
      filterList6: [
        {
          key: "ti",
          value: "标题",
        },
        {
          key: "eti",
          value: "英文标题",
        },
        {
          key: "cti",
          value: "中文标题",
        },
        {
          key: "ab",
          value: "摘要",
        },
        {
          key: "eab",
          value: "英文摘要",
        },
        {
          key: "cab",
          value: "中文摘要",
        },
        {
          key: "cl",
          value: "权利要求",
        },
        {
          key: "ecl",
          value: "英文权利要求",
        },
        {
          key: "d",
          value: "说明书",
        },
        {
          key: "eds",
          value: "英文说明书",
        },
        {
          key: "cets",
          value: "标题与摘要的中英文",
        },
        {
          key: "ap",
          value: "申请人",
        },
        {
          key: "fap",
          value: "第一申请人",
        },
        {
          key: "addr",
          value: "申请人地址",
        },
        {
          key: "aee",
          value: "专利权人",
        },
        {
          key: "caee",
          value: "当前专利权人",
        },
        {
          key: "in",
          value: "发明人",
        },
        {
          key: "ag",
          value: "代理机构",
        },
        {
          key: "at",
          value: "搭理人",
        },
        {
          key: "n",
          value: "号码",
        },
        {
          key: "dn",
          value: "公开（公告）号",
        },
        {
          key: "an",
          value: "申请号",
        },
        {
          key: "pr",
          value: "优先权号",
        },
        {
          key: "dd",
          value: "公开（公告）日期",
        },
        {
          key: "ddy",
          value: "公开（公告）日期年",
        },
        {
          key: "ddm",
          value: "公开（公告）日期月",
        },
        {
          key: "ad",
          value: "申请日期",
        },
        {
          key: "ady",
          value: "申请日期年",
        },
        {
          key: "adm",
          value: "申请日期月",
        },
        {
          key: "pctDate",
          value: "PCT进入国家阶段日",
        },
        {
          key: "ipc",
          value: "国际IPC分类",
        },
        {
          key: "ipc-section",
          value: "IPC分类-部",
        },
        {
          key: "ipc-class",
          value: "IPC分类-大类",
        },
        {
          key: "ipc-subclass",
          value: "IPC分类-小类",
        },
        {
          key: "ipc-group",
          value: "IPC分类-大组",
        },
        {
          key: "ipc-subgroup",
          value: "IPC分类-小组",
        },
        {
          key: "ipc-main",
          value: "IPC主分类",
        },
        {
          key: "ipcm-section",
          value: "IPC主分类-部",
        },
        {
          key: "ipcm-class",
          value: "IPC主分类-大类",
        },
        {
          key: "ipcm-subclass",
          value: "IPC主分类-小类",
        },
        {
          key: "ipcm-group",
          value: "IPC主分类-大组",
        },
        {
          key: "ipcm-subgroup",
          value: "IPC主分类-小组",
        },
        {
          key: "uspc",
          value: "USPC分类号",
        },
        {
          key: "uspcc",
          value: "USPC大类",
        },
        {
          key: "fi",
          value: "日本FI分类",
        },
        {
          key: "ft",
          value: "日本F-term分类",
        },
        {
          key: "loc",
          value: "洛迦诺分类",
        },
        {
          key: "cpc",
          value: "CPC联合专利分类",
        },
        {
          key: "ls",
          value: "专利有效性",
        },
        {
          key: "type",
          value: "专利类型",
        },
        {
          key: "cc",
          value: "国家代码",
        },
        {
          key: "acc",
          value: "申请人国家代码",
        },
        {
          key: "kc",
          value: "文献类型",
        },
        {
          key: "lang",
          value: "语言",
        },
        {
          key: "apt",
          value: "申请人类型",
        },
        {
          key: "ap-zip",
          value: "申请人邮编",
        },
        {
          key: "country",
          value: "国家",
        },
        {
          key: "province",
          value: "省份",
        },
        {
          key: "city",
          value: "城市",
        },
        {
          key: "aeet",
          value: "专利权人类型",
        },
        {
          key: "caeet",
          value: "当前专利权人类型",
        },
        {
          key: "agc",
          value: "代理机构代码",
        },
        {
          key: "legalTag",
          value: "法律标签",
        },
        {
          key: "legalEvent",
          value: "法律事件",
        },
        {
          key: "maintainYears",
          value: "维持年份",
        },
        {
          key: "citedCount",
          value: "引证数",
        },
        {
          key: "citingCount ",
          value: "被引证数",
        },
        {
          key: "level ",
          value: "评级",
        },
        {
          key: "reexamination.fsPerson",
          value: "复审请求人",
        },
        {
          key: "reexamination.wxPerson",
          value: "无效请求人",
        },
        {
          key: "rtl",
          value: "复审合议组组长",
        },
        {
          key: "rpe",
          value: "复审主审员",
        },
        {
          key: "reexamination.decisionPoints",
          value: "审查决定要点",
        },
        {
          key: "oralProceedings.requester",
          value: "口审请求人",
        },
        {
          key: "oralProceedings.primaryExaminer",
          value: "口审主审员",
        },
        {
          key: "oralProceedings.teamLeader",
          value: "口审合议组组长",
        },
        {
          key: "oralProceedings.attendExaminer",
          value: "口审参审员",
        },
        {
          key: "oralProceedings.date",
          value: "口审时间",
        },
        {
          key: "judgment.date",
          value: "裁判文书时间",
        },
        {
          key: "judgment.title",
          value: "裁判文标题",
        },
        {
          key: "judgment.caseId",
          value: "裁判文书案号",
        },
        {
          key: "judgment.court",
          value: "裁判文书法院",
        },
        {
          key: "judgment.province",
          value: "裁判文书省",
        },
        {
          key: "judgment.city",
          value: "裁判文书市",
        },
        {
          key: "judgment.accuser",
          value: "裁判文书原告",
        },

        {
          key: "judgment.defendant",
          value: "裁判文书被告",
        },
        {
          key: "judgment.lawyerA",
          value: "裁判文书原告律师",
        },
        {
          key: "judgment.lawyerB",
          value: "裁判文书被告辩护律师",
        },
        {
          key: "judgment.firmA",
          value: "裁判文书原告律所",
        },
        {
          key: "judgment.firmB",
          value: "裁判文书被告律所",
        },
      ],
    };
  },
  watch: {
    isAllType(val) {
      if (val) {
        this.types = this.typeList;
      } else {
        this.types = [];
      }
    },
    isAllCountry(val) {
      if (val) {
        this.country = this.list;
      } else {
        this.country = [];
      }
    },
    types(val) {
      if (val.length >= 4) {
        this.isAllType = true;
        this.isIndeter = false;
      } else if (val.length > 0) {
        this.isIndeter = true;
      } else {
        this.isIndeter = false;
        this.isAllType = false;
      }
    },
    country(val) {
      if (val.length >= this.list.length) {
        this.isAllCountry = true;
        this.isIndeter1 = false;
      } else if (val.length > 0) {
        this.isIndeter1 = true;
      } else {
        this.isIndeter1 = false;
        this.isAllCountry = false;
      }
    },
    search(val) {
      this.isLoading = true;
      this.inputKey = val;
      this.getSuggest(val);
    },
  },
  created() {
    if (
      this.$vuetify.breakpoint.name == "sm" ||
      this.$vuetify.breakpoint.name == "xs"
    ) {
      this.iphone = true;
    } else {
      this.iphone = false;
    }
    this.activeKey = this.searchType || 0;
    if (this.searchType && this.searchType == 0) {
      this.inputKey = this.searchKey;
    }
    if (this.searchType && this.searchType == 1) {
      this.totalTemp = this.searchKey;
      this.getCountrys();
      let country = localStorage.getItem("countries");
      if (country) {
        this.country = JSON.parse(country);
      } else {
        this.country = [];
      }
    }
    if (this.searchType && this.searchType == 3) {
      this.textData = this.searchKey;
    }
    this.getCountrys();
    this.getHistory();
  },
  methods: {
    ...mapActions("search", [
      "querySug",
      "saveStrategy",
      "strategyCount",
      "getSearchLike",
      "getSearchImg",
      "imgUpload",
      "getIpcList",
      "getIpcChildList",
      "getCompList",
      "getCompListChild",
      "getHistoryList"
    ]),
    ...mapMutations('search',['setSearchType','setSearchKey']),


    getCountrys() {
      let list = this.rspnation.split(";;;");
      this.list = list;
      list.forEach((item) => {
        let c = {
          name: getPnc(item),
          code: item,
        };
        this.cList.push(c);
      });
    },

    //200多行的js
    createSearch() {
      let tsInfo = this.tsInfo;
      let cpcInfo = this.cpcInfo;
      let nameInfo = this.nameInfo;
      let appInfo = this.appInfo;
      let customInfo = this.customInfo;
      let temp = "";
      let temp1 = "";
      let temp2 = "";
      let temp3 = "";
      let temp4 = "";
      let temp5 = "";
      for (let n in tsInfo.key3) {
        if (tsInfo.key3[n]) {
          if (!tsInfo.key2[n]) {
            this.$message({
              type: "info",
              message: "请选择关键字",
            });
            return false;
          }
          tsInfo.key1[n] = tsInfo.key1[n] ? tsInfo.key1[n] : "AND";
          if (n == "ts0") {
            tsInfo.key1["ts0"] = "";
          }
          temp =
            temp +
            tsInfo.key1[n] +
            " " +
            tsInfo.key2[n] +
            ":(" +
            tsInfo.key3[n] +
            ") ";
        }
      }
      for (let n in cpcInfo.key3) {
        if (cpcInfo.key3[n]) {
          if (!cpcInfo.key2[n]) {
            this.$message({
              type: "info",
              message: "请选择分类号",
            });
            return false;
          }
          cpcInfo.key1[n] = cpcInfo.key1[n] ? cpcInfo.key1[n] : "AND";
          temp1 =
            temp1 +
            cpcInfo.key1[n] +
            " " +
            cpcInfo.key2[n] +
            ":(" +
            cpcInfo.key3[n] +
            ") ";
        }
      }
      for (let n in nameInfo.key3) {
        if (nameInfo.key3[n]) {
          if (!nameInfo.key2[n]) {
            this.$message({
              type: "info",
              message: "请选择名称/地址",
            });
            return false;
          }
          nameInfo.key1[n] = nameInfo.key1[n] ? nameInfo.key1[n] : "AND";
          temp2 =
            temp2 +
            nameInfo.key1[n] +
            " " +
            nameInfo.key2[n] +
            ":(" +
            nameInfo.key3[n] +
            ") ";
        }
      }
      for (let n in appInfo.key3) {
        if (appInfo.key3[n]) {
          if (!appInfo.key2[n]) {
            this.$message({
              type: "info",
              message: "请选择号码",
            });
            return false;
          }
          appInfo.key1[n] = appInfo.key1[n] ? appInfo.key1[n] : "AND";
          temp3 =
            temp3 +
            appInfo.key1[n] +
            " " +
            appInfo.key2[n] +
            ":(" +
            appInfo.key3[n] +
            ") ";
        }
      }
      for (let n in appInfo.key3) {
        if (appInfo.key3[n]) {
          // if(!appInfo.key2[n]) {
          //   this.$message({
          //     type: 'info',
          //     message: '请选择日期'
          //   })
          //   return false
          // }
          appInfo.key1[n] = appInfo.key1[n] ? appInfo.key1[n] : "AND";
          temp3 =
            temp3 +
            appInfo.key1[n] +
            " " +
            appInfo.key2[n] +
            ":(" +
            appInfo.key3[n] +
            ") ";
        }
      }
      for (let n in customInfo.key3) {
        if (customInfo.key3[n]) {
          if (!customInfo.key2[n]) {
            this.$message({
              type: "info",
              message: "请选择自定义字段",
            });
            return false;
          }
          customInfo.key1[n] = customInfo.key1[n] ? customInfo.key1[n] : "AND";
          temp5 =
            temp5 +
            customInfo.key1[n] +
            " " +
            customInfo.key2[n] +
            ":(" +
            customInfo.key3[n] +
            ") ";
        }
      }
      if (this.dateInfo.key2) {
        this.dateInfo.key1 = this.dateInfo.key1 ? this.dateInfo.key1 : "AND";
        let date = "";
        if (this.dateKey == "2") {
          date = this.date;
        }
        if (this.dateKey == "1") {
          date = "[" + this.date + " TO " + this.date1 + "]";
        }
        temp4 = this.dateInfo.key1 + " " + this.dateInfo.key2 + ":" + date;
      } else {
        // this.$message({
        //   type: 'info',
        //   message: '请选择日期'
        // })
      }
      let totalTemp = temp + temp1 + temp2 + temp3 + temp4 + temp5;
      if (
        totalTemp.indexOf("AND") == "0" ||
        totalTemp.indexOf("OR") == "0" ||
        totalTemp.indexOf("NOT") == "0"
      ) {
        totalTemp = totalTemp.slice(3);
      }
      this.totalTemp = totalTemp;
      this.getPatentCount(this.totalTemp);
    },
    goSearch() {
      let country = JSON.stringify(this.country);
      localStorage.setItem("countries", country);
      this.createSearch();
      this.setSearchType(1);
      this.setSearchKey(this.totalTemp);
      this.$router.push({
        path: "/search/result",
        query: {
          str: this.totalTemp,
        },
      });
    },
    clearSearch() {
      this.tsInfo.key2 = {};
      this.tsInfo.key3 = {};
      this.cpcInfo.key2 = {};
      this.cpcInfo.key3 = {};
      this.nameInfo.key2 = {};
      this.nameInfo.key3 = {};
      this.appInfo.key2 = {};
      this.appInfo.key3 = {};
      // this.tsInfo = { key1: {}, key2: {}, key3: {} };
      // this.cpcInfo = { key1: {}, key2: {}, key3: {} };
      // this.nameInfo = { key1: {}, key2: {}, key3: {} };
      // this.appInfo = { key1: {}, key2: {}, key3: {} };
    },
    goSearch1() {
      if (!this.totalTemp) {
        this.$message({
          type: "info",
          message: "请输入检索式",
        });
      } else {
        this.setSearchType(1);
        this.setSearchKey(this.totalTemp);
        let country = JSON.stringify(this.country);
        localStorage.setItem("countries", country);
        this.$router.push({
          path: "/search/result",
          query: {
            str: this.totalTemp,
          },
        });
      }
    },
    clearSearch1() {
      this.totalTemp = "";
    },
    saveSearch() {
      if (!this.totalTemp) {
        this.$message.info("请输入检索式");
        return false;
      }
      let data = {
        params: {
          name: this.totalTemp,
          value: this.totalTemp,
        },
      };
      let _this = this;
      this.saveStrategy({
        data: data,
        handle(res) {
          if (res.success) {
            _this.$message({
              type: "success",
              message: "保存成功",
            });
            _this.queryList = true;
          } else {
            _this.$message({
              type: "error",
              message: "保存失败",
            });
          }
        },
      });
    },
    getQuery(val) {
      this.queryList = val;
    },
    goLikeSearch() {
      let key = this.textData;
      if (!key) {
        this.$message({
          type: "info",
          message: "请输入关键词",
        });
        return false;
      }
      let _this = this;
      let data = {
        keywords: key,
      };
      this.setSearchKey(this.textData);
      data = Qs.stringify(data);
      this.setSearchType(3);
      this.getSearchLike({
        data: data,
        handle(res) {
          let value = res.searchQuery;
          _this.$router.push({
            path: "/search/result",
            query: {
              str: value,
            },
          });
        },
      });
    },

   
    reduce(list, index) {
      if (list == "ts") {
        let key = this.tsNumList[index];
        this.tsNumList.splice(index, 1);
        this.$nextTick(() => {
          for (let i in this.tsInfo) {
            for (let j in this.tsInfo[i]) {
              if (j == key) {
                delete this.tsInfo[i][j];
              }
            }
          }
        });
      }
      if (list == "cpc") {
        let key = this.cpcNumList[index];
        this.cpcNumList.splice(index, 1);
        this.$nextTick(() => {
          for (let i in this.cpcInfo) {
            for (let j in this.cpcInfo[i]) {
              if (j == key) {
                delete this.cpcInfo[i][j];
              }
            }
          }
        });
      }
      if (list == "name") {
        let key = this.nameNumList[index];
        this.nameNumList.splice(index, 1);
        this.$nextTick(() => {
          for (let i in this.nameInfo) {
            for (let j in this.nameInfo[i]) {
              if (j == key) {
                delete this.nameInfo[i][j];
              }
            }
          }
        });
      }
      if (list == "app") {
        let key = this.appNumList[index];
        this.appNumList.splice(index, 1);
        this.$nextTick(() => {
          for (let i in this.appInfo) {
            for (let j in this.appInfo[i]) {
              if (j == key) {
                delete this.appInfo[i][j];
              }
            }
          }
        });
      }
      if (list == "custom") {
        let key = this.customNumList[index];
        this.customNumList.splice(index, 1);
        this.$nextTick(() => {
          for (let i in this.customInfo) {
            for (let j in this.customInfo[i]) {
              if (j == key) {
                delete this.customInfo[i][j];
              }
            }
          }
        });
      }
      // console.log('dddd',index)
      // console.log('tsNum-1',this.tsNumList)
      // this.tsNumList.splice(index,1)
      // console.log('tsNum-2',this.tsNumList)
      // list.splice(index,1)
    },
    async fetchUsers(item) {
      // http://test.iprdb.com:8080
      let res = await axios.get('/ajax/ipc/load_children?code='+item.code)
      console.log('ddd', res)
      let children = res.data
      this.setData(item.code,children)
    },
    openComp(val) {
      this.compKey = val
      this.getCompanyList()
      this.compDialog = true
    },
    getCompanyList() {
      let data = {
        params: {
          q: this.compKeyWord
        }
      }
      let _this = this
      this.getCompList({data: data,handle(res) {
        let data = res
        data.forEach((item)=>{
          item.children = []
        })
        _this.compList = data
      }})
    },
    searchComp() {
      this.getCompanyList()
    },
    getIpcs() {
      let data = {
        params: {
          q: this.ipcKeyWord
        }
      }
      let _this = this
      this.getIpcList({data: data,handle(res) {
        let data = res.ipcTreeNodes
        data.forEach((item)=>{
          item.children = []
        })
        _this.ipcList = data
      }})
    },
     
     openIpc(val) {
      this.ipcDialog = true
      this.ipcKey = val
      this.getIpcs()
    },
    searchIpc() {
      this.getIpcs()
    },
    toseniorSearch() {
      let codes = this.sendItems.map((item)=>{
        return item.code
      })
      console.log('codes', codes)
      let value = codes.join(' OR ')
      this.cpcInfo.key3[this.ipcKey] = value
      this.ipcDialog = false
    },
    goSearch2() {
      let codes = this.sendItems.map((item)=>{
        return item.code
      })
      let value = codes.join(' OR ')
      let temp = 'ipc:( ' + value + ' )'
      this.$router.push({
        path: "/search/result",
        query: {
          str: temp,
        },
      });
    },
    setData1(key, value, list) {
      let compList = list || this.compList
      compList.forEach((item,index)=>{
          if(item.code == key) {
            item.children = value
            this.$set(compList, index, item)
          }else {
            if(item.children&&item.children.length>0) {
              this.setData1(key, value, item.children)
            }
          }
      })
      this.$nextTick(()=>{
        this.compList = JSON.parse(JSON.stringify(compList))
      })
    },
    sendIpc(val) {
      console.log('val', val)
      this.sendItems.push(val)
    },
     ipcDelete(id) {
      this.sendItems.forEach((item,index)=>{
        if(item.id == id) {
          this.sendItems.splice(index,1)
        }
      })
    },
    compDelete(id) {
      this.sendItems1.forEach((item,index)=>{
        if(item.id == id) {
          this.sendItems1.splice(index,1)
        }
      })
    },
    sendComp(val) {
      this.sendItems1.push(val)
    },
    toseniorSearch1() {
      let codes = this.sendItems1.map((item)=>{
        return item.name
      })
      let value = codes.join(' OR ')
      this.nameInfo.key3[this.compKey] = value
      this.compDialog = false
    },
     
    goSearch3() {
      let codes = this.sendItems1.map((item)=>{
        return item.name
      })
      let value = codes.join(' OR ')
      let temp = 'ap:( ' + value + ' )'
      this.$router.push({
        path: "/search/result",
        query: {
          str: temp,
        },
      });
    },
    goHistory() {
      this.$router.push({
        path: "/user/history",
      });
    },
    getHistory() {
      let _this = this;
      let data = {
        params: {
          page: 1,
          pageSize: 100,
        },
      };
      this.getHistoryList({
        data: data,
        handle(res) {
          let list = JSON.parse(res.message);
          list.forEach((item) => {
            if (_this.history1.indexOf(item.keywords) < 0) {
              _this.history1.push(item.keywords);
            }
          });
        },
      });
    },
  },
};
</script>

<style scoped>
</style>